<jqxWindow [zIndex]="998" theme="material" [resizable]="canResize"
  [showCollapseButton]="true" [title]="title" [draggable]="isDraggable"
  (onOpen)="windowOpened.emit()" [autoOpen]="shouldOpen">
  <!-- Window Title Place Holder: Required by jqxWindow -->
  <div></div>
  <div>
    <div class="content" [class.with-actions]="!!actions">
      <mcg-loader [showLoader]="loading"></mcg-loader>
      <ng-content></ng-content>
    </div>

    @if(actions !== null) {
      <div class="actions">
        <div *ngFor="let action of actions">
          <mcg-button
          [label]="action.label"
          [prefixIconName]="action.prefixIconName"
          [suffixIconName]="action.suffixIconName"
          [disabled]="action.disable"
          [size]="action.size"
          (clicked)="actionButtonClicked.emit(action)"
        >
        </mcg-button>
          <label *ngIf="action.type === 'checkbox'">
            <input type="checkbox" [(ngModel)]="action.value" [disabled]="action.disable"
              (change)="action.value = !action.value; buttonClicked(action)" [checked]="action.value">
            {{ action.label }}
          </label>
        </div>
      </div>
    }
  </div>
</jqxWindow>
